// 在线文档
import React, {memo} from 'react'
import styled from 'styled-components'
import Processing from "@/icons/common/processing.png";

const DocMsg = styled.div`
  width: 240px;
  height: 111px;
  border: 1px solid #D9D9D9;
  border-radius: 4px;
  color: #595959;
  .docDetail {
    height: 61px;
    padding: 8px;
    border-bottom: 1px solid #E9E9E9;
  }
  .docTitle {
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .docContent {
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .docType {
    display: flex;
    align-items: center;
    height: 32px;
    font-size: 12px;
    padding-left: 8px;
    font-weight: 400;
    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
`

const RenderDocMsg = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  return(
    <DocMsg onClick={()=>window.open(message.linkUrl)}>
      <div className="docDetail">
        <div className="docTitle">{message.title}</div>
        <div className="docContent">{message.description}</div>
      </div>
      <div className="docType"><img src={Processing} />待办</div>
    </DocMsg>
  )
})

export default RenderDocMsg
